var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaskGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1079.995,
    viewBox: "0 0 1920 1079.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M1920,1079.649H0V-.347H1920Z",
    transform: "translate(0 0.347)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.02,
    y1: 0.05,
    x2: 0.934,
    y2: 0.825,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0267c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53b1ff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2",
    x: -500,
    y: 0,
    width: 1030,
    height: 777.995,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 15,
    dy: 15,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5930ef",
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_3",
    x: 1420,
    y: 330,
    width: 1030,
    height: 778,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 15,
    dy: 15,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5930ef",
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    opacity: 0.05,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47557",
    "data-name": "Group 47557",
    transform: "translate(-440 60)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 440, -60)",
    filter: "url(#Path_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2",
    d: "M440,0C196.995,0,0,225.751,0,504.228s108.555,0,351.561,0S880,782.705,880,504.228,683.005,0,440,0Z",
    transform: "translate(-440 60)",
    fill: "url(#linear-gradient-2)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 440, -60)",
    filter: "url(#Path_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2",
    "data-name": "Path 3",
    d: "M440,0C683.005,0,880,225.752,880,504.231s-108.555,0-351.561,0S0,782.711,0,504.231,196.995,0,440,0Z",
    transform: "translate(1480 390)",
    fill: "url(#linear-gradient-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup1);
export default __webpack_public_path__ + "static/media/Mask Group 1.55c0b37754c70d77a91fb0d1042573c3.svg";
export { ForwardRef as ReactComponent };